import React from 'react';
import Button from '@material-ui/core/Button';
import { PropTypes } from 'prop-types';
import { NavLink } from 'react-router-dom';

import './style.css';
import '../../grid.css';


const Btn = ({
    onClick, label, to, color, className, size, fullWidth, variant, disabled, type,
}) =>
    (to ? (
        <Button
            type={type}
            variant={variant}
            className={className}
            fullWidth={fullWidth}
            onClick={onClick}
            component={NavLink}
            to={to}
            color={color}
            size={size}
            disabled={disabled}
        >
            {label}
        </Button>
    ) : (
        <Button
            type="button"
            variant={variant}
            className={className}
            fullWidth={fullWidth}
            onClick={onClick}
            color={color}
            size={size}
            disabled={disabled}
        >
            {label}
        </Button>
    ));

Btn.propTypes = {
    onClick: PropTypes.func,
    label: PropTypes.string.isRequired,
    to: PropTypes.string,
    color: PropTypes.string,
    className: PropTypes.string,
    size: PropTypes.string,
    fullWidth: PropTypes.string,
    variant: PropTypes.string,
    disabled: PropTypes.bool,
    type: PropTypes.string,
};

Btn.defaultProps = {
    to: null,
    color: null,
    className: 'button',
    size: 'small',
    fullWidth: true,
    onClick: null,
    variant: 'outlined',
    disabled: false,
    type: 'button',
};

export default Btn;



// WEBPACK FOOTER //
// ./src/components/Btn/index.js